import IconStarNeg from "@folksam/ui/components/icons/IconStarNeg";

import { Box, Flex } from "../cores";

type props = {
  value: string;
};

const EuroNCAP = ({ value }: props) => {
  const iconStarNegArr = [];
  const stars = value.replace("Pre", "Före").split("|");
  const intRating = parseInt(stars[0]);
  for (let i = 0; i < intRating; i++) {
    iconStarNegArr.push(<IconStarNeg key={i} />);
  }
  return (
    <Flex
      as="span"
      sx={{
        whiteSpace: "nowrap",
        color: "quanternaryScale.5",
        flexDirection: "column",
        fontWeight: "bold",
        minWidth: "fit-content",
        height: "100%",
      }}
    >
      {iconStarNegArr.length !== 0 ? <Box>{iconStarNegArr}</Box> : null}
      {stars[1] ? (stars[1] !== "-" ? stars[1] : null) : null}
    </Flex>
  );
};

export default EuroNCAP;
